import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.mfa_required) return data;
    setUser(data);
    return data;
  };

  const verifyMfa = async (ticket, code) => {
    const { data } = await api.post("/auth/mfa/verify", { ticket, code });
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    setUser(false);
  };

  return <Ctx.Provider value={{ user, setUser, login, register, verifyMfa, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
